import { localizeParam, matchParam } from '$lib/i18n-url';

const localizedParam = localizeParam(2, 'l_confirmation', {
	en: 'confirmation',
	de: 'aufladungsbestaetigung'
});

export const match = (param) => matchParam(param, localizedParam);
